import React, {useCallback, useEffect, useState} from 'react';
import {Button, Grid, Paper, Select, MenuItem} from "@mui/material";
import {FormProvider, useForm} from "react-hook-form";
import {multipleOfUnitFloor, useSharedStyles} from "../util/constant";
import {getData, postData} from "../util/__fetch";
import ATSnackbar from "../layout/ATSnackbar";
import FNOIronCondor from "./FNOIronCondor";
import FNOBuy from "./FNOBuy";
import websocketService from "../websocket/WebSocketService";
import {Controller} from "react-hook-form";

const endpoint = `/algo-trading/api/fno/config`;

const indexes = [{name: "BANKNIFTY", gap: 100}, {name: "NIFTY", gap: 50},
  {name: "FINNIFTY", gap: 50}, {name: "MIDCPNIFTY", gap: 25}, {name: "SENSEX", gap: 100}, {name: "BANKEX", gap: 100}];

const FNOEntry = ({user}) => {
  const shrinkProp = {shrink: true};
  const [open, setOpen] = useState(false)
  const [warningMessage, setWarningMessage] = useState("")
  const [selectedIndex, setSelectedIndex] = useState("")
  const [errorNotification, setErrorNotification] = useState()
  const [indexLtp, setIndexLtp] = useState({})
  const [strikes, setStrikes] = useState({})
  const [moneyness, setMoneyness] = useState("")
  const methods = useForm();
  const { handleSubmit, control, formState: { errors }} = methods
  const classes = useSharedStyles();

  // fetch the selected index from the backend
  const getSelectedIndex = useCallback(() => {
    function setSelectedIndexFromResponse(responseIndex) {
        if (responseIndex) {
            setStrikes({})
            setSelectedIndex(responseIndex?.optionIndex)
            setMoneyness(responseIndex?.moneyness)
        }
    }

    getData(endpoint + '/selected-index', user, setSelectedIndexFromResponse, setWarningMessage, () => {
    })
      .then(() => {
      });
  }, [user]);

  useEffect(() => {
    getSelectedIndex()
  }, [user, getSelectedIndex]);

  useEffect(() => {
      if (!selectedIndex || moneyness === undefined || moneyness === "") {
          return
      }
    getData(`/algo-trading/api/fno/select-index/${selectedIndex}/${moneyness}`, user, setIndexLtp, setWarningMessage, () => {
    })
      .then(r => {
      });
  }, [user, selectedIndex, moneyness]);

  useEffect(() => {
    if (!indexLtp || Object.keys(indexLtp).length === 0 || !selectedIndex || selectedIndex === "") {
      return;
    }
    // when for the same selected Index, strikes are present and current ltp lies within the range of gap from reference ltp,
    // then do not re-form the strikes
    if (strikes?.ceStrikes?.length > 0 && strikes?.index === selectedIndex
      && Math.abs(strikes?.refLtp - indexLtp?.lastTradedPrice) <= indexes.find(i => i.name === selectedIndex)?.gap) {
      return;
    }
    const selectedIndexObject = indexes.find(index => index?.name === selectedIndex)
    const atmStrike = multipleOfUnitFloor(indexLtp?.lastTradedPrice, selectedIndexObject?.gap);
    // to get CE strikes increment the atm strike by the gap value
    // to get PE strikes decrement the atm strike by the gap value
    const ceStrikes = [];
    const peStrikes = [];

    for (let i = -5; i <= 5; i++) {
      ceStrikes.push(String(atmStrike + i * selectedIndexObject?.gap, ""));
      peStrikes.push(String(atmStrike - i * selectedIndexObject?.gap, ""));
    }
    const newStrikes = {
      'index': selectedIndex,
      'refLtp': indexLtp?.lastTradedPrice,
      'ceStrikes': ceStrikes,
      'peStrikes': peStrikes
    }
    console.log("New Strikes: ", newStrikes);
    setStrikes(newStrikes);
    //ignore dependency array warning, as we are using indexLtp to get the latest ltp
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [indexLtp]);

  const chooseIndexColor = (currentIndex) => {
    if (selectedIndex === currentIndex) {
      return "primary"
    }
    return "inherit"
  }
  const refreshLTP = (event) => {
    event.preventDefault()
    clearOldMessages()
    getData('/algo-trading/api/fno/reconnect-ltp', user, (() => {
    }), (() => {
    }), (() => {
    }))
      .then(r => {
      })
  }
  const refreshConnections = (event) => {
    event.preventDefault()
    clearOldMessages()
    getData('/algo-trading/api/fno/reconnect-connections', user, (() => {
    }), (() => {
    }), (() => {
    }))
      .then(r => {
      })
  }
  const selectIndex = (event) => {
    event.preventDefault()
    clearOldMessages()
    setStrikes({})
    setSelectedIndex(event.target.value)
  }

  useEffect(() => {
    websocketService.connect().then(r => {
      websocketService.subscribe('/fno/error-notifications', message => {
        // console.log(message?.body);
        setErrorNotification(message?.body);
        setOpen(true);
      });
    })
  }, []);


  const clearOldMessages = useCallback(() => {
    setWarningMessage("")
    setErrorNotification("")
    setOpen(false)
  }, []);

  const onSubmit = data => {
    console.log('1', data)
    postData('/algo-trading/api/fno/config', user, data?.config, setWarningMessage, setWarningMessage, () => {})
  }

  const handleMoneynessChange = (event) => {
    setMoneyness(event.target.value);
  };

  return (
    <Grid container item xs={12} md={12} m={1} spacing={2}>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)} className={classes.form}>
          <Grid container item xs={12} md={12} spacing={2}>
            &nbsp;
            {errorNotification &&
              <ATSnackbar message={errorNotification} open={open} setOpen={setOpen} severity="warning"/>
            }
            {warningMessage && (
              <ATSnackbar message={warningMessage} open={open} setOpen={setOpen} severity="warning"/>)}
          </Grid>
          <Grid container item xs={12} md={12} spacing={2} padding={0.5}>
            <Grid item xs={12} md={6} lg={5}>
              <Paper elevation={4} sx={{padding: 1}}>
                <Grid container item xs={12} md={12} lg={12} spacing="2">
                  {indexes.map((d, index) => (
                    <Grid item key={index} m={1}>
                      <Button variant="contained" size="small" color={chooseIndexColor(d?.name)} type="submit"
                              value={d?.name}
                              onClick={selectIndex}>{d?.name}</Button>
                    </Grid>
                  ))}

              <Controller
                  name="moneyness"
                  label="moneyness"
                  control={control}
                  render={({ field }) => <Select {...field}
                      error={errors?.['moneyness'] !== undefined}
                      helperText={errors && errors?.['moneyness']?.message}
                      required
                      value={moneyness ? moneyness : '0'}
                      onChange={handleMoneynessChange}
                  >
                      <MenuItem key='ATM-4' value='4'>ATM - 4</MenuItem>
                      <MenuItem key='ATM-3' value='3'>ATM - 3</MenuItem>
                      <MenuItem key='ATM-2' value='2'>ATM - 2</MenuItem>
                      <MenuItem key='ATM-1' value='1'>ATM - 1</MenuItem>
                      <MenuItem key='ATM' value='0'>ATM</MenuItem>
                  </Select>}
                  />
                </Grid>
              </Paper>
            </Grid>
          </Grid>
          <Grid container item xs={12} md={12} spacing={2}>
            <Grid container item xs={12} md={12} lg={5} alignSelf={"flex-start"}>
              <FNOIronCondor
                shrinkProp={shrinkProp}
                user={user}
                selectedIndex={selectedIndex}
                wm={setWarningMessage}
                open={open}
                setOpen={setOpen}
                indexes={indexes}
                cePeStrikes={strikes}
              />
            </Grid>
            <Grid container item xs={12} md={12} lg={7}>
              <FNOBuy
                user={user}
                selectedIndex={selectedIndex}
                classes={classes}
                setOpen={setOpen}
                setWarningMessage={setWarningMessage}
                clearOldMessages={clearOldMessages}
              />
            </Grid>
          </Grid>
          <Grid container item xs={12} md={6} spacing={2} padding={0.5}>
            <Grid item justifyItems={"end"}>
              <Paper elevation={1} sx={{padding: 1, display: 'flex', flexDirection: 'row', gap: 1}}>
                <Grid item>
                  <Button variant="contained" size="small" onClick={refreshLTP} color="secondary">Reset LTP</Button>
                </Grid>
                <Grid item>
                  <Button variant="contained" size="small" onClick={refreshConnections} color="secondary">Refresh
                    Connections</Button>
                </Grid>
              </Paper>
            </Grid>
          </Grid>
        </form>
      </FormProvider>
    </Grid>
  );
}

export default FNOEntry;